const initialState = {
    searchReplaceValue:[],
};
export const actionTypes = {
    SEARCH_REPLACE_TABLE:"SEARCH_REPLACE_TABLE",
};

export const actions = {
    search_replace_table: function (data) {
        return {
            type: actionTypes.SEARCH_REPLACE_TABLE,
            data
        }
    }
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.SEARCH_REPLACE_TABLE:{
            return {...state,searchReplaceValue:action.data}
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/replaceReducer.js